import { ProductCategoryHelper } from '..';

export const useProductCategory = () => {
	let productCategoryHelper = new ProductCategoryHelper();
	return {
		productCategoryHelper,
		activeProductCategory: productCategoryHelper.active()
	};
};
